/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'flag': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z"/>'
  }
})
